// bundled bootstrap
import "/node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";